import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff', width: 10, height: 10
    }
}))

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'date', label: 'Дата'},
    { id: 'summ', label: 'Сумма'},
    { id: 'payment', label: 'Платежная система'},
    { id: 'tag', label: 'Тип операции'},
    { id: 'login', label: 'Логин кассира'},
];

const getRows = (replenishment) => {
    return replenishment.map((item) => {
        return {
            id: item.id,
            date: getDate(item.event_date),
            summ: item.air ? new Intl.NumberFormat('ru-RU').format(item.summ) + ' ₽ (воздух)' : new Intl.NumberFormat('ru-RU').format(item.summ) + ' ₽' , 
            payment: item.payment,
            tag: item.tag === 'replenishment' ? 'Баланс' : item.tag === 'replenishment sport' && 'Сопртивный баланс',
            login: item.login,
        }
    })
} 

export {
    useStyles,
    columns,
    getRows
}